var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostItemPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 211,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h360v211H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 43,
    r: 22,
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 25,
    width: 140,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 89,
    width: 245,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 123,
    width: 292,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 145,
    width: 318,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 167,
    width: 216,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 48,
    width: 60,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  }))));
}
export default SvgPostItemPlaceholder;